export default __webpack_public_path__ + "static/media/airplane.e34bc031.png";